import { useState } from 'react'
import { MATRIX_LABELS as SHARED_MATRIX_LABELS } from '@crm/shared'
import { confirm } from '../../../shared/ui/confirmStore'
import type { RequestItemPriority } from '../../../shared/api/types'
import type { ItemRow } from './ItemsTable'
import { PRIORITY_LABELS, MATRIX_LABELS } from './ItemsTable'

const MATRIX_OPTIONS = SHARED_MATRIX_LABELS

// Подвал ItemsTable: «+ Добавить», «Очистить всё», bulk-выбор матрицы и
// приоритета для всех строк сразу. Вынесено из ItemsTable, чтобы тот не
// уезжал за 500-строчный лимит после добавления DnD.
export function ItemsTableFooter({
  items,
  onAdd,
  onClearAll,
  onChange,
}: {
  items: ItemRow[]
  onAdd: () => void
  onClearAll: () => void
  onChange: (idx: number, field: string, value: string | number | boolean) => void
}) {
  const [bulkPriority, setBulkPriority] = useState<RequestItemPriority | ''>('')
  const [bulkMatrix, setBulkMatrix] = useState<string>('')

  return (
    <div className="flex flex-wrap gap-3 px-2 py-2 border-t border-gray-100 items-center">
      <button
        type="button"
        onClick={onAdd}
        className="text-xs text-brand-600 hover:text-brand-700 font-medium"
      >
        + Добавить строку
      </button>
      <button
        type="button"
        onClick={async () => {
          if (items.every((i) => !i.partNumber.trim())) return
          if (!(await confirm({ title: 'Очистить все позиции?', confirmText: 'Очистить' }))) return
          onClearAll()
        }}
        className="text-xs text-gray-400 hover:text-red-500"
      >
        Очистить всё
      </button>

      <div className="flex items-center gap-1.5">
        <span className="text-xs text-gray-400">Матрица для всех:</span>
        <select
          value={bulkMatrix}
          onChange={(e) => {
            const val = e.target.value
            setBulkMatrix(val)
            if (val) {
              items.forEach((_, idx) => onChange(idx, 'matrix', val))
            }
          }}
          className="px-1.5 py-0.5 text-xs border border-gray-200 rounded bg-white focus:outline-none focus:ring-1 focus:ring-brand-500"
        >
          <option value="">— выбрать —</option>
          {MATRIX_OPTIONS.map((m) => (
            <option key={m} value={m}>
              {MATRIX_LABELS[m] ?? m}
            </option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-1.5 ml-auto">
        <span className="text-xs text-gray-400">Приоритет для всех:</span>
        <select
          value={bulkPriority}
          onChange={(e) => {
            const val = e.target.value as RequestItemPriority | ''
            setBulkPriority(val)
            if (val) {
              items.forEach((_, idx) => onChange(idx, 'priority', val))
            }
          }}
          className="px-1.5 py-0.5 text-xs border border-gray-200 rounded bg-white focus:outline-none focus:ring-1 focus:ring-brand-500"
        >
          <option value="">— выбрать —</option>
          {Object.entries(PRIORITY_LABELS).map(([k, v]) => (
            <option key={k} value={k}>
              {v}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}
